'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var getDateParts = function (fd, time) {
    var parts = fd(time, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    });
    var month = parts[0], day = parts[2], year = parts[4];
    return {
        year: year.value,
        month: month.value,
        day: day.value,
    };
};
var getAge = function (date) {
    var today = new Date();
    var birthDate = new Date(date);
    var age = today.getFullYear() - birthDate.getFullYear();
    var months = today.getMonth() - birthDate.getMonth();
    if (months < 0 || (months === 0 && today.getDate() < birthDate.getDate())) {
        age -= 1;
    }
    return age;
};
var formatBirthday = function (fm, fd, date) {
    var dateParts = getDateParts(fd, date);
    var dayWithOrdinal = fm({ id: 'componentLib.appWide.ordinal' }, { day: dateParts.day });
    var age = getAge(date);
    var ageText = 'componentLib.appWide.age';
    return dateParts.month + " " + dayWithOrdinal + ", " + dateParts.year + " (" + fm({ id: ageText }) + ": " + age + ")";
};

exports.formatBirthday = formatBirthday;
exports.getAge = getAge;
exports.getDateParts = getDateParts;
